import eventSpaceIcon from '../assets/amenitiesIcons/event-clubhouse.png';
import fuelDockIcon from '../assets/amenitiesIcons/fuel-dock.png';
import parkingOnShoreIcon from '../assets/amenitiesIcons/parking.png';
import pumpOutIcon from '../assets/amenitiesIcons/pump-out.png';
import restroomsIcon from '../assets/amenitiesIcons/restrooms.png';
import shoreAccessIcon from '../assets/amenitiesIcons/shore-access.png';
import wifiIcon from '../assets/amenitiesIcons/wifi.png';

const amenityIconSources = {
  eventSpace: eventSpaceIcon,
  fuelDock: fuelDockIcon,
  parkingOnShore: parkingOnShoreIcon,
  pumpOut: pumpOutIcon,
  restrooms: restroomsIcon,
  shoreAccess: shoreAccessIcon,
  wifi: wifiIcon,
};

export const getAmenityIconSrc = key => amenityIconSources[key] || null;
